import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";
import { AuditLogRow, Paginated } from "../types/dtos";

export type AuditLogListParams = { page?: number; pageSize?: number; q?: string; entityType?: string };

export function useAuditLogs(params: AuditLogListParams): UseQueryResult<Paginated<AuditLogRow>> {
  return useQuery({
    queryKey: ["audit-logs", params],
    queryFn: async () => (await staffApi.get<Paginated<AuditLogRow>>("/audit-logs", { params })).data,
    placeholderData: (prev: Paginated<AuditLogRow> | undefined) => prev,
  });
}
